"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./NavigateBackButton.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigateBackButton = function NavigateBackButton(_ref) {
  var navHeading = _ref.navHeading,
      rightNavHeading = _ref.rightNavHeading,
      handleCancle = _ref.handleCancle,
      handleBack = _ref.handleBack,
      leftArrowImage = _ref.leftArrowImage;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "nav-back-btn-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "navigate-back-navigate",
    "data-testid": "navigate-back-navigate",
    onClick: handleBack
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
    src: leftArrowImage,
    alt: "arrow"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "navigate-content"
  }, navHeading)), rightNavHeading && /*#__PURE__*/_react.default.createElement("button", {
    className: "nav-cancel-btn",
    "data-testid": "nav-cancel-btn",
    onClick: handleCancle
  }, rightNavHeading));
};

var _default = NavigateBackButton;
exports.default = _default;